export const checkLogin = (state, userToken) => {
  if (userToken) {
    state.isLogin = true;
    state.token = userToken;
  } else {
    state.isLogin = false;
    state.token = null;
  }
};

export const userInfo = (state, Datalist) => {
  state.userInfo = Datalist;
};

export const carCount = (state, count) => {
  state.carCount = count;
};



// WEBPACK FOOTER //
// ./src/vuex/mutations.js